import React from 'react'
import './Home.css'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import BlockFullMain from '../../components/Common/BlockFullMain'
import { TrendingFlat } from '@mui/icons-material'

export default function HomeJCK() {
  return (
    <BlockFullMain
      title='home.jck2024.title'
      description={['home.jck2024']}
      bgColor='#111'
      image='https://meteor.stullercloud.com/das/133099542?wid=1400'
    >
      <Button
        size='large'
        variant='contained'
        component={Link}
        to='/store'
        endIcon={<TrendingFlat />}
        data-cy='home-banner-button'
      >
        <FormattedMessage id='common.buyNow' />
      </Button>
    </BlockFullMain>
  )
}
